/** @jsx jsx */
import React from "react";
import { jsx } from "@emotion/core";

import { ColoredH2 } from "../../components/ColoredHeader";
import CheckList from "../../components/CheckList";
import { PrimaryCTAHyperlink } from "../../components/PrimaryCTA";

import { colors } from "../../theme";

const InterviewNext = () => (
    <>
        <ColoredH2 color={colors.secondary8}>So, what’s next?</ColoredH2>
        <p>
            The next step is to complete an interview for some of our
            experienced tutors to mark.
        </p>
        <CheckList
            doneItems={["Sign up", "Submit application"]}
            currentItem="Complete interview"
        />

        <PrimaryCTAHyperlink href="/tutors/secure/ta-bookinterview.html">
            Next →
        </PrimaryCTAHyperlink>
    </>
);

export default InterviewNext;
